define('Components/NewsWidget/js/views/NewsWidgetInstanceView',['jquery','WidgetInstanceView',
        'app',
        'template!Components/NewsWidget/templates/default',
        'template!Components/NewsWidget/templates/2-cols',
    ],
    function($,WidgetInstanceView,
             app,
             defaultTemplate,
             colsTemplate
    ){
        var intervalID,
            touchstartX = 0,
            touchendX = 0,
            nbItems= 0;
    return WidgetInstanceView.extend({
        name:'NewsWidgetInstanceView',
        activeSlide: 0,
        events: {
            'click .prev':'prevSlide',
            'click .next':'nextSlide',
        },
        afterRender:function(){
            var view = this,
                $slider = view.$('.slider');
            if (this.model.getInterval() > 0) {
                var time = this.model.getInterval() * 1000;
                view.setInterval(time);
            }
            $slider.on('touchstart',function(event){
                touchstartX = event.originalEvent.changedTouches[0].screenX;
            });
            $slider.on('touchend',function(event){
                touchendX = event.originalEvent.changedTouches[0].screenX;
                view.handleGesture();
            });
        },
        setInterval:function(time){
            var view = this;
            intervalID = setInterval(function(){
                view.nextSlide();
            },time);
        },
        handleGesture:function(){
            if (touchendX < touchstartX && touchendX != touchstartX) {
                this.nextSlide();
            }
            if (touchendX > touchstartX && touchendX != touchstartX) {
                this.prevSlide();
            }
        },
        getTemplate:function(){
            switch(this.model.getTemplate()){
                case 'default': default: return defaultTemplate; break;
                case '2-cols': return colsTemplate; break;
            }
        },
        toSlide: function(toPrev){
            var view = this,
                activeSlide = view.activeSlide,
                model = this.model;
              if (model.getInterval() > 0) {
                clearInterval(intervalID);
                var time = model.getInterval() * 1000;
                view.setInterval(time);
              }
            nbItems = model.getNbMaxNews();
            if(toPrev){
                if(activeSlide > 0) {
                    activeSlide--;
                } else {
                    activeSlide = nbItems - 1;
                }
            }else{
                if(activeSlide < nbItems - 1) {
                    activeSlide++;
                } else {
                    activeSlide = 0;
                }
            }

            view.activeSlide = activeSlide;
            view.$('.slider ul').css('left', -(100 * activeSlide) + '%');
        },
        nextSlide:function(){
            this.toSlide(false);
        },
        prevSlide: function(){
            this.toSlide(true);
        }

    })
});
